<template>
  <div>
    <div class="card shadow">
      <div class="card-header bg-transparent">
        <div>
          <h3 class="mb-0">
            {{ $tc('message.prestation',1) }}
          </h3>
        </div>
      </div>

      <div class="card-body">
        <b-container>
          <b-row class="">
            <b-col sm="7" class="text-left" v-if="can">
              <b-button
                  variant="primary"
                  class="mb-2"
                  size="sm"
                  @click="ImprimerFacture"
              >
                {{ $t('message.print') }}  {{ $tc('message.facture', 1) }}
              </b-button>
              <b-button class="mb-2"
                        variant="primary"
                        @click="ImprimerFactureProforma"
                        size="sm"
              >
                {{ $t('message.imprimerProforma') }}
              </b-button>
              <b-button class="mb-2"
                        variant="primary"
                        @click="ImprimerFacture"
                        size="sm">
                {{ $t('message.imprimerDefinitive') }}
              </b-button>
            </b-col>
            <b-col sm="5" class="text-right" v-if="can">
              <b-button
                  variant="outline-dark"
                  class="mb-2"
                  size="sm"
                  @click="mailRecouvrementFacture"
              >
                {{ $t('message.recouvrer') }}
              </b-button>
              <b-button
                  variant="outline-dark"
                  class="mb-2"
                  size="sm"
                  @click="mailRappelFacture"
              >
                {{ $t('message.rappeler') }}
              </b-button>
              <b-button
                  variant="outline-warning"
                  size="sm"
                  class="mb-2"
                  @click="updateFacture"
              >
                {{ $t('message.edit') }}
              </b-button>
              <b-button
                  variant="outline-danger"
                  class="mb-2"
                  size="sm"
                  v-b-modal.delete-modal
              >
                {{ $t('message.delete') }}
              </b-button>
              <!--
              <b-button variant="dark" class="mb-2" @click="mailRappelFacture">
                  {{ $t('message.rappeler') }}
              </b-button>

              <b-button variant="danger" v-b-modal.delete-modal>
                  {{ $t('message.delete') }}
              </b-button>
-->

            </b-col>
          </b-row>
          <b-modal
              id="delete-modal"
              size="sm"
              header-bg-variant="danger"
              header-text-variant="light"
              :title="$t('message.delete') + ' ' + $tc('message.facture',1)"
              hide-footer
          >
            <div class="d-block text-center">
              <h3>{{ $t('message.delete') }} {{ mFacture.date_facturation }}?</h3>
            </div>

            <div class="d-block float-right">
              <b-button variant="danger" @click="deleteFacture">
                {{ $t('message.delete') }}
              </b-button>

              <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                {{ $t('message.cancel') }}
              </b-button>
            </div>
          </b-modal>
        </b-container>
        <b-container>
          <h3 class="heading text-center mt-3 mb-3">{{$t('message.infoGenerale')}}</h3>

          <b-row>
            <div class="col-12">
              <div class="timeline-box h-100">
                <div class="box-title">
                  <i class="fa fa-list" aria-hidden="true"></i>
                  {{ $t('message.detailsFacture') }}
                </div>
                <div class="box-content">
                  <div class="box-item column-display-style column-display-style-without-mb">
                    <div class="row">
                      <div class="col-6 text-right">
                        <p><strong>{{ $t('message.nomEtablissement') }}</strong></p>
                      </div>
                      <div class="col-6 text-left">
                        <p>{{ etablissement }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 text-right">
                        <p><strong>{{ $t('message.nomPatient') }}</strong></p>
                      </div>
                      <div class="col-6 text-left">
                        <p>{{ patientName }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 text-right">
                        <p><strong>{{ $t('message.dateFacturation') }}</strong></p>
                      </div>
                      <div class="col-6 text-left">
                        <p>{{ formattedDate(mFacture.date_facturation) }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 text-right">
                        <p><strong>{{ $t('message.status') }}</strong></p>
                      </div>
                      <div class="col-6 text-left">
                        <p>{{ getStatut(mFacture.statut) }}</p>
                      </div>
                    </div>
                    <div class="row" v-if="mFacture.statut == 'Rejeté'">
                      <div class="col-6 text-right">
                        <p><strong>{{ $tc('message.reasons',2) }}</strong></p>
                      </div>
                      <div class="col-6 text-left">
                        <p>{{ mFacture.motif }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="box-footer">
                </div>
              </div>
            </div>
            <!--                        <div class="col-6">-->
            <!--                            <div class="timeline-box h-100">-->
            <!--                                <div class="box-title">-->
            <!--                                    <i class="fa fa-money-bill" aria-hidden="true"></i>-->
            <!--                                    {{ $t('message.amount') }}-->
            <!--                                </div>-->
            <!--                                <div class="box-content">-->
            <!--                                    <div class="box-item">-->
            <!--                                        <div class="row">-->
            <!--                                            <div class="col-6 text-right">-->
            <!--                                                <p><strong>{{ $t('message.totalHorsRemise') }}</strong></p>-->
            <!--                                                <p><strong>{{ $t('message.remise') }}</strong></p>-->
            <!--                                                <p style="margin-top: 20px"><strong class="medsur-primary-color">{{ $t('message.totalAvecRemise') }}</strong></p>-->
            <!--                                            </div>-->
            <!--                                            <div :class="`${Number(mFacture.total_hors_remise) >= 100000 ? 'col-4' : 'col-3'} text-right`">-->
            <!--                                                <p>{{ displayNumber(mFacture.total_hors_remise) }}</p>-->
            <!--                                                <p>{{ displayNumber(mFacture.remise) }}</p>-->
            <!--                                                <p><strong class="total-amount medsur-primary-color m-0">{{ displayNumber(mFacture.total_avec_remise) }}</strong></p>-->
            <!--                                            </div>-->
            <!--                                        </div>-->

            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                                <div class="box-footer">-->
            <!--                                </div>-->
            <!--                            </div>-->
            <!--                        </div>-->
          </b-row>

          <p class="heading text-center mt-5">{{$t('message.prestationDetail')}}</p>

          <b-row v-if="prestations.length > 0" class="my-2">
            <b-col sm="12">
              <b-table
                  striped
                  responsive
                  hover
                  bordered
                  :items="prestations"
                  :fields="prestationsField"
              >
                <template v-slot:cell(name)="data">
                  <p class="mb-0 capitalize-first-letter">{{ data.value }}</p>
                </template>

                <template v-slot:cell(price)="data">
                  <p class="mb-0 capitalize-first-letter">{{ displayNumber(data.value) }}</p>
                </template>

                <template v-slot:cell(reduction)="data">
                  <p class="mb-0 capitalize-first-letter">{{ displayNumber(data.value) }}</p>
                </template>

                <!-- Optional default data cell scoped slot -->
                <template v-slot:cell()="data">
                  <p class="mb-0">{{ data.value }}</p>
                </template>

                <template v-slot:custom-foot="data">
                  <b-tr>
                    <b-th class="align-middle">
                      <p
                          class="mb-0 text-center total-label"
                      >
                        {{$t('message.totalPrixPrestation')}}
                      </p>
                    </b-th>
                    <b-th colspan="2">
                      <div class="mb-0 text-center">
                        <p class="mb-0 d-inline-block text-right">
                          <span class="first-operation">{{ displayNumber(totalPrestation) }}</span><br>
                          <!--<span>{{ displayNumber(totalPrestation) }}</span><br>-->
                          <span class="last-operation">{{ displayNumber(totalReduction) }}</span>
                          <strong>{{ displayNumber(totalPrestation - totalReduction) }}</strong>
                        </p>
                      </div>
                    </b-th>
                    <!--                                            <b-th variant="secondary">Type 1</b-th>-->
                    <!--                                            <b-th variant="primary" colspan="3">Type 2</b-th>-->
                    <!--                                            <b-th variant="danger">Type 3</b-th>-->
                  </b-tr>
                </template>
              </b-table>
            </b-col>
          </b-row>

        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import _ from "lodash";
import moment from "moment";
import i18n from "@/plugins/i18n";

export default {
  name: "Show",

  computed: {
    ...mapGetters(["facture", 'hasAdminRole','isComptable',
      'hasGestionnaireRole', 'hasMedecinControleRole','isComptable','hasAssistante']),

    prestationsField:function(){
      let fArray =  [
        { key: 'name', label: i18n.t('message.nomPrestation')},
        { key: 'price', label: i18n.t('message.price')},
        { key: 'reduction', label: i18n.t('message.remise')},
      ];
      if (this.can) {
        fArray.push({ key: 'statut', label: i18n.t('message.status')});
        fArray.push({ key: 'motif', label: i18n.tc('message.reasons',1)});
      }
      return fArray;
    },

    can: function () {
      return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.isComptable ||this.hasAssistante;
    },

    mFacture:function () {
      return this.facture;
    },

    etablissement:function(){
      if (this.mFacture.hasOwnProperty('etablissement')){
        return this.mFacture.etablissement.name;
      }
      return '';
    },

    patientName: function() {
      if (this.mFacture.hasOwnProperty('dossier') && this.mFacture.dossier.hasOwnProperty('patient')){
        return this.mFacture.dossier.patient.user.nom + ' ' + this.mFacture.dossier.patient.user.prenom;
      }
      return '';
    },

    totalPrestation:function(){
      let total = 0;

      _.forEach(this.mFacture.prestations,function (prestation) {
        if (prestation.statut == 'Validé'){
          total += parseFloat(prestation.prestation_etablissement.prix)
        }
      })

      return total;
    },

    totalReduction:function () {
      let total = 0;

      _.forEach(this.mFacture.prestations,function (prestation) {
        if (prestation.statut == 'Validé') {
          total += parseFloat(prestation.prestation_etablissement.reduction)
        }
      })

      return total;
    },

    prestations: function () {
      return this.mFacture.prestations.map(item => ({
        name: item.prestation_etablissement.prestation.nom,
        price: item.prestation_etablissement.prix,
        reduction: item.prestation_etablissement.reduction,
        statut: item.statut,
        motif: item.statut == 'Rejété' && item.motif ? item.motif : '',
      }));
    },

  },

  data() {
    return {
      facture_id: this.$route.params.facture,
      paginationOptions: {
        enabled: true,
        mode: 'records',
        perPageDropdown: [10, 15, 20]
      },
    }
  },

  methods: {
    displayNumber(value) {
      return Number(value).toLocaleString('fr') + ' FCFA';
    },

    getColorStatus(status) {
      switch (status) {
        case 'Initié': return '--primary';
      }
    },

    getStatut(item){
      if ( item == 'Validé'  ) return 'Facture validée par le Médecin control';
      else if ( item == 'Rejeté' )  return 'Facture rejetée par le MC';
      else if ( item == 'Archivé' )  return 'Facture destinée au Module de Comptabilité Interne de Medsurlink';
      else return item;
    },
    ImprimerFacture(){
      let args = {
        facture: this.facture_id
      };

      this.$store.dispatch("printFacture", { args });
    },

    ImprimerFactureProforma(){
      let args = {
        facture: this.facture_id
      };

      this.$store.dispatch("printFactureProforma", { args });
    },

    updateFacture(){
      this.$router.push({ name: 'edit-facture', params: { facture: this.facture_id } });
    },

    formattedDate(date) {
      return moment(date).format('DD-MM-YYYY');
    },

    getFacture() {
      let args = {
        facture: this.facture_id,
      };
      this.$store.dispatch("getFacture", {args});
    },

    deleteFacture(){
      let args = {
        facture: this.facture_id,
      };

      let successMessage = this.$i18n.t('message.factureDeleted');
      let errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.error')
      };

      this.$store.dispatch('deleteFacture', {args, successMessage, errorMessages})
    },

    mailRecouvrementFacture(){
      let args = {
        facture: this.facture_id,
      };

      let successMessage = this.$i18n.t('message.mailEnvoye');
      let errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.error')
      };

      this.$store.dispatch('mailRecouvrementFacture', {args, successMessage, errorMessages})
    },

    mailRappelFacture(){
      let args = {
        facture: this.facture_id,
      };

      let successMessage = this.$i18n.t('message.mailEnvoye');
      let errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.error')
      };

      this.$store.dispatch('mailRappelFacture', {args, successMessage, errorMessages})
    }
  },

  mounted() {
    this.getFacture();
  }
}
</script>

<style scoped lang="scss">
$primary-color: #2dcecc;

p {
  font-size: 0.9rem !important;
}

.timeline-box {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2) !important;
  .box-title {
    i {
      color: $primary-color !important;
    }
  }
}

.total-label {
  font-size: 0.65rem !important;
  letter-spacing: 1px;
  font-weight: 600 !important;
  text-transform: uppercase;
}

.first-operation {
  position: relative;

  &:after {
    content: '';
    position: absolute;
    width: 8px;
    height: 1px;
    background: black;
    left: -28px;
    top: 150%;
  }
}

.last-operation {
  position: relative;
  &:after {
    $width: 130%;

    content: '';
    height: 4px;
    width: $width;
    border-top: 1px solid black;
    border-bottom: 1px solid black;
    position: relative;
    left: -10px;
    /*left: calc(50%);*/
    /*bottom: -.575rem;*/
    display: block;
  }
}

.total-amount {
  position: relative;

  &:before {
    content: '';
    height: 4px;
    width: 130%;
    border-top: 1px solid $primary-color;
    border-bottom: 1px solid $primary-color;
    position: relative;
    right: 10%;
    top: -8px;
    /*bottom: -.575rem;*/
    display: block;
  }
}

.custom-badge {
  $background-outer: #ebebebd6;
  $background-inner: $primary-color;

  /*.t {
      $background-inner: red;
  }*/

  display: inline-block;
  justify-content: space-between;
  align-items: center;
  border-radius: 30px;
  padding: 3px;
  color: #f4f4f4 !important;
  background: $background-outer;
  border: 0.5px solid $background-inner;
  /*border: 4px solid #f4f4f4;*/

  .left {
    margin-left: .7rem;
    /*line-height: .9;*/
  }

  .right {
    width: 80%;
    background: $background-inner;
    border-radius: 4rem;
    padding: 3px 15px;
    /*box-shadow: inset 4px 0 3px 3px rgba(0,0,0,.5);*/
    /*text-shadow: 0 5px 5px #000;*/
    font-size: 13px;
    text-align: center;
    letter-spacing: 1.1px;
    font-weight: 500;
  }
}

.custom-badge-1 {
  $background-outer: #ebebebd6;
  $background-inner: $primary-color;
  $color: #f4f4f4;

  background: $background-inner;
  color: $color;
  border-radius: 4rem;
  font-size: 13px;
  text-align: center;
  letter-spacing: 1.1px;
  font-weight: 500;
  position: relative;
  padding: 3px 15px 3px 20px;
  cursor: pointer;

  &:before {
    $dimension: 9px;

    content: '';
    width: $dimension;
    height: $dimension;
    border-radius: 50%;
    background: white;
    /*border: 1px solid $color;*/
    position: absolute;
    left: 7px;
    top: 6px;
  }

  &:hover {
    background: white;
    border: 1px solid $background-inner;
    color: $background-inner;

    &:before {
      background: $background-inner;
    }
  }
}
</style>
